(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class selectionMenu extends HTMLElement {
  constructor() {
  super();
  this.open = false;
  this.opener = this.querySelector('.selector');
  this.container = this.querySelector('.selection-menu');
  this.opener.addEventListener('click', event => {
  event.preventDefault();
  this.opener.classList.toggle('open', !this.open);
  document.body.classList.toggle('open-selection-menu', !this.open);
  this.container.classList.toggle('hidden', this.open)
  this.open = !this.open;
  });
  }
  }
  customElements.define('selection-menu', selectionMenu);

  } catch(e) { console.error(e); }
})();
})();
